// Helpers puros para identificar radios (TETRA/MCX) y construir items de lista
// y targets de llamada directa. Sin dependencias de Vue: el discriminador es la
// categoria del device (categoryData.radioType), no el uniqueId. El id que el
// backend espera para kind=direct es la ISSI (attributes.interSystemId), con
// fallback al id numerico interno — mismo contrato que el mapa legacy.

const RADIO_TYPES = ['tetra', 'mcx']

// ISSI cruda (attributes.interSystemId) o null si no esta definida o viene vacia.
function getIssi(raw) {
  const issi = raw && raw.attributes ? raw.attributes.interSystemId : undefined
  return issi !== undefined && issi !== null && issi !== '' ? issi : null
}

// ¿El raw del monitor (device payload) es un radio llamable por categoria?
export function isRadioDevice(raw) {
  const rt = raw && raw.categoryData && raw.categoryData.radioType
  return RADIO_TYPES.indexOf(rt) !== -1
}

// Provider del device (mcx|tetra). El backend enruta la llamada por esto.
export function getRadioProvider(raw) {
  return raw && raw.categoryData ? raw.categoryData.radioType : undefined
}

// Identificador intersistema (ISSI). Vive en attributes.interSystemId; si no
// esta definido o viene vacio, cae al id numerico interno del device.
export function getRadioKalanId(raw) {
  const issi = getIssi(raw)
  if (issi !== null) return issi
  return raw ? raw.id : undefined
}

// kalanId como string para el backend; null si no hay ISSI ni id (evita
// mandar el string "undefined").
function kalanIdString(raw) {
  const k = getRadioKalanId(raw)
  return k != null ? String(k) : null
}

// Item de la lista de radios privados, derivado de un MapMonitor (device).
export function toRadioItem(monitor) {
  const raw = (monitor && monitor.data) || {}
  const issi = getIssi(raw)
  return {
    monitorId: monitor && monitor.id,
    deviceId: raw.id,
    kalanId: kalanIdString(raw),
    issi,
    uniqueId: raw.uniqueId,
    name: (monitor && monitor.title) || raw.name || raw.uniqueId,
    groupName: raw.groupName || '',
    provider: getRadioProvider(raw),
    online: !!(monitor && monitor.status === 'online'),
    callable: issi != null || raw.id != null,
    monitor,
  }
}

// Lista completa de radios desde el objeto id->MapMonitor (this._monitors).
// Ordena: online primero, luego alfabetico por nombre.
export function buildRadioDeviceList(monitors) {
  const out = []
  const keys = Object.keys(monitors || {})
  for (let i = 0; i < keys.length; i++) {
    const mon = monitors[keys[i]]
    if (mon && mon.entityType === 'device') {
      const raw = mon.data || mon
      if (isRadioDevice(raw)) {
        out.push(toRadioItem(mon))
      }
    }
  }
  out.sort((a, b) => {
    if (a.online !== b.online) return a.online ? -1 : 1
    return String(a.name).localeCompare(String(b.name))
  })
  return out
}

// Target de llamada directa que se guarda en map-v2/radioTetraTarget. Lleva
// provider + kalanId (ISSI) ademas de los campos de display. null si no es radio.
export function buildRadioTarget(monitor) {
  const raw = (monitor && monitor.data) || monitor
  if (!isRadioDevice(raw)) return null
  return {
    type: 'device',
    monitorId: (monitor && monitor.id) || null,
    deviceId: raw.id,
    kalanId: kalanIdString(raw),
    issi: getIssi(raw),
    uniqueId: raw.uniqueId,
    name: (monitor && monitor.title) || raw.name || raw.uniqueId,
    groupName: raw.groupName || '',
    provider: getRadioProvider(raw),
  }
}
